import Detail from '../views/pages/detail';
import ListResto from '../views/pages/resto-list';
import Favorite from '../views/pages/favorite';

const routes = {
  '/': ListResto, // default page
  '/list-restaurant': ListResto,
  '/detail/:id': Detail,
  '/favorite-restaurant': Favorite,
};

export default routes;
